export const FEATURE_FLAGS = {
	GLOBAL_POLICY_SEARCH_ENABLED: 'globalPolicySearchEnabled',
	NON_CONTINGENT_STAGES_ENABLED: 'nonContingentStagesEnabled',
	ERP_ORGANISATION_VALIDATION_ENABLED: 'erpOrganisationValidationEnabled',
	ADVANCE_DISBURSEMENTS_ENABLED: 'advanceDisbursementsEnabled',
	DEFAULT_PREMIUM_SETTINGS_COMMISSIONS_ENABLED: 'defaultPremiumSettingsCommissionsEnabled',
	EMAIL_FOOTER_LEGAL_ENTITY_ENABLED: 'emailFooterLegalEntityEnabled',
}

export const ENV_VARIABLES = {
	INDICATOR_COUNTRY: 'indicatorCountry',
	INDICATOR_NAME: 'indicatorName',
}
